import { GameLaunchStatus } from "@onmo/eon-streaming";

export type ToastMessageVideoMap = {
  [key in GameLaunchStatus]?: string;
};

//#region metadata.id of each feature card (configured in admin-tool) - group: GUIDE_VIDEOS_GROUP
export const GUIDE_VIDEOS_GROUP = "guide_videos";

export const ONBOARDING_VIDEO_ID = "onboarding_video";
export const CONSOLE_VIDEO_ID = "console_video";
export const GAME_LAUNCH_VIDEO_ID = "game_launch";
export const GAME_STREAM_VIDEO_ID = "game_stream";
export const CONSOLE_CONTROLS_VIDEO_ID = "console_controls";
export const TOAST_MESSAGE_VIDEO_IDS: ToastMessageVideoMap = {
  [GameLaunchStatus.STATUS_STEAMLOGIN_SUCCESS]: "steam_login_success",
  [GameLaunchStatus.STATUS_STEAMLOGIN]: "steam_login",
  [GameLaunchStatus.STATUS_GAMERUNNING]: "game_running",
};
export const SIDE_MENU_VIDEO_GUIDE =
  "https://www.youtube.com/playlist?list=PLEIJke4XelJo";
//@endregion metadata.id of each card in GUIDE_VIDEOS_GROUP
